import * as React from 'react';
import { Button } from '@progress/kendo-react-buttons';

export type FaultCodesErrorType = 'all' | 'dtc' | 'j1939';

type Props = {
  selectedErrorType: FaultCodesErrorType;
  onSelect: (type: FaultCodesErrorType) => void;
  t: (key: string, options?: any) => string;
};

export function FaultCodesErrorTypeTabs({
  selectedErrorType,
  onSelect,
  t,
}: Props) {
  return (
    <div>
      <Button
        className="button-tabs"
        themeColor={selectedErrorType === 'all' ? 'primary' : null}
        onClick={() => onSelect('all')}
      >
        {t('fault_mode_all')}
      </Button>
      <Button
        className="button-tabs"
        themeColor={selectedErrorType === 'dtc' ? 'primary' : null}
        onClick={() => onSelect('dtc')}
      >
        {t('fault_mode_e_code')}
      </Button>
      <Button
        className="button-tabs"
        themeColor={selectedErrorType === 'j1939' ? 'primary' : null}
        onClick={() => onSelect('j1939')}
      >
        {t('fault_mode_j1939')}
      </Button>
    </div>
  );
}
